import preparedReducer from './reducer';
import { releaseNotesRequest } from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'releaseNotes';

export const selectors = state => state[SLICE_NAME];
export const getReleaseNotes = state => state[SLICE_NAME].items;
export const getReleaseNotesLoaded = state => state[SLICE_NAME].loaded;

export const actions = {
  requestReleaseNotes: releaseNotesRequest,
};
